import { CHARTS_COLORS_TXT } from '../constants'
import { TOngoingRFPResponce } from '../types'
import '../styles.scss'
import { useRef } from 'react'
import { Tooltip } from '../../../components/Tooltip/Tooltip'

export const OngoingRFPsChart = ({ data }: { data: TOngoingRFPResponce }) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <div
      className="charts_ongoing-contracts_container half-width"
      data-testid="chartsOngoingRFPContainer"
    >
      <div
        className="charts_title new-design"
        data-testid="chartsOngoingRFPTitle"
      >
        Ongoing RFP
      </div>
      <div
        className="charts_ongoing-contracts_total_container row gap-8"
        data-testid="chartsOngoingRFPTotalContainer"
      >
        <div
          className="charts_ongoing-contracts_total"
          data-testid="chartsOngoingRFPTotal"
        >
          {data?.rfp_total_count}
        </div>
        <div
          className="charts_ongoing-contracts_total-title"
          data-testid="chartsOngoingRFPTotalTitle"
        >
          RFP
        </div>
      </div>
      <div
        className="charts_ongoing-contracts_chart"
        ref={ref}
        data-testid="chartsOngoingRFPChart"
      >
        {data &&
          Object.keys(data).map((key) => {
            if (key !== 'rfp_total_count' && +data[key] > 0) {
              return (
                <Tooltip
                  title={`${CHARTS_COLORS_TXT[key]?.name}: ${+data[key]}`}
                >
                  <div
                    className="charts_ongoing-contracts_chart-part"
                    key={key}
                    style={{
                      backgroundColor: CHARTS_COLORS_TXT[key].color,
                      width: `${100 * (+data[key] / +data?.rfp_total_count)}%`
                    }}
                  />
                </Tooltip>
              )
            }
          })}
        {data && !data.rfp_total_count && (
          <div
            className="charts_ongoing-contracts_chart-part"
            style={{
              backgroundColor: CHARTS_COLORS_TXT.empty_state.color,
              width: `100%`
            }}
          />
        )}
      </div>
    </div>
  )
}
